import Products from "./products";
import Warehouses from "./warehouses";
import Orders from "./orders";

export default {
  Products,
  Warehouses,
  Orders,
};
